export default (name) => {
	const hasReduxDevtools = window && window.__REDUX_DEVTOOLS_EXTENSION__;

	return hasReduxDevtools
		? window.__REDUX_DEVTOOLS_EXTENSION__({ name, id: name })
		: (f) => f;
};



// WEBPACK FOOTER //
// ./src/shared/util/ReduxDevTools.js